export default __webpack_public_path__ + "static/GmarketSansLight-5d3bc33796f1cb3705f8841ba0af2f88.otf";